import type { IconNode } from '../types';

/**
 * @name razor-blade
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgOGgtMlY2SDR2MkgydjhoMnYyaDE2di0yaDJaIiAvPgogIDxwYXRoIGQ9Ik02IDExdjIiIC8+CiAgPHBhdGggZD0iTTEwIDEySDYiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTggMTJoLTQiIC8+CiAgPHBhdGggZD0iTTE4IDExdjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/razor-blade
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const razorBlade: IconNode = [
  ['path', { d: 'M22 8h-2V6H4v2H2v8h2v2h16v-2h2Z', key: 'll3klo' }],
  ['path', { d: 'M6 11v2', key: 'dh4kw5' }],
  ['path', { d: 'M10 12H6', key: '15f2ro' }],
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
  ['path', { d: 'M18 12h-4', key: '1qd862' }],
  ['path', { d: 'M18 11v2', key: '15s1ed' }],
];

export default razorBlade;
